import * as TYPES from './type';
export default {
  //教学课程
  [TYPES.COURSE_LIST](state, {
    result
  }) {
    state.courseList = result.result
  },
  [TYPES.COURSE_INFO](state, {
    result,
    type
  }) {
    state.courseInfo[type] = result.result
  },
  [TYPES.COURSE_CHAPTER](state, {
    result,
    type
  }) {
    state.courseChapter = {
      root: '',
      child: '',
      add: ''
    }
    state.courseChapter[type] = result.result
  },
  [TYPES.COURSE_CHAPTER_RES](state, {
    result,
    type
  }) {
    state.courseChapterRes[type] = result
  },
  [TYPES.SYSTEM_MAJOR](state, result) {
    state.systemList = result
  },
  [TYPES.COURSE_MENU_LIST](state, result) {
    state.courseMenuList = result
  },

  [TYPES.SK_COURSE_LIST](state, {
    result
  }) {
    state.SKcourseList = result.result
  },

  [TYPES.COURSE_MATERIAL_INFO](state, {
    result,
    type
  }) {
    state.courseMaterialInfo[type] = result.result
  },

  [TYPES.COURSE_CLOSE](state, {
    result,
    type
  }) {
    state.courseClose[type] = result.result
  },
}



// WEBPACK FOOTER //
// ./src/store/jxCourse/mutations.js